import { i as formatPrice } from "@theme/utils";
import VariantSelects from "@theme/variant-selects";
//#region frontend/islands/variant-radios.js
var VariantRadios = class extends VariantSelects {
	connectedCallback() {
		this.querySelectorAll("fieldset:not([aria-hidden=\"true\"])").forEach((fieldset) => {
			this.initRovingTabindex(fieldset);
		});
		this.subscribed = true;
		this._onRecipeChange = () => {
			this.updateOptions();
			this.updateSelectedValues();
		};
		document.addEventListener("recipe:change", this._onRecipeChange);
		this._onPurchaseOptionChange = (event) => {
			if (event.detail?.sectionId !== this.dataset.section) return;
			this.subscribed = event.detail.subscribed;
			this.updatePerCartonPrices();
		};
		document.addEventListener("purchase-option:change", this._onPurchaseOptionChange);
	}
	disconnectedCallback() {
		if (this._onRecipeChange) document.removeEventListener("recipe:change", this._onRecipeChange);
		if (this._onPurchaseOptionChange) document.removeEventListener("purchase-option:change", this._onPurchaseOptionChange);
	}
	updateSelectedValues() {
		super.updateSelectedValues();
		this.updatePerCartonPrices();
	}
	updatePerCartonPrices() {
		this.querySelectorAll("[data-per-carton-price]").forEach((el) => {
			const count = Number(el.dataset.cartonCount);
			if (!count) return;
			const cents = this.subscribed ? Number(el.dataset.subscribePriceCents) : Number(el.dataset.priceCents);
			el.textContent = `${formatPrice(Math.floor(cents / count))} ${window.variantStrings.perCarton}`;
		});
	}
	initRovingTabindex(fieldset) {
		const radios = [...fieldset.querySelectorAll("input[type=\"radio\"]")];
		const syncTabindex = () => {
			const checked = radios.find((r) => r.checked && !r.disabled);
			const fallback = radios.find((r) => !r.disabled);
			radios.forEach((r) => {
				r.setAttribute("tabindex", r === (checked ?? fallback) ? "0" : "-1");
			});
		};
		syncTabindex();
		fieldset.addEventListener("change", syncTabindex);
		radios.forEach((radio) => {
			radio.addEventListener("keydown", (e) => {
				const available = radios.filter((r) => !r.disabled);
				const idx = available.indexOf(radio);
				if (idx === -1) return;
				let target = null;
				if (e.key === "ArrowRight" || e.key === "ArrowDown") {
					e.preventDefault();
					target = available[(idx + 1) % available.length];
				} else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
					e.preventDefault();
					target = available[(idx - 1 + available.length) % available.length];
				} else if (e.key === "Home") {
					e.preventDefault();
					target = available[0];
				} else if (e.key === "End") {
					e.preventDefault();
					target = available[available.length - 1];
				}
				if (target) {
					radios.forEach((r) => r.setAttribute("tabindex", "-1"));
					target.setAttribute("tabindex", "0");
					target.focus();
					target.checked = true;
					target.dispatchEvent(new Event("change", { bubbles: true }));
				}
			});
		});
	}
	updateOptions() {
		this.options = Array.from(this.querySelectorAll("fieldset")).map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
		});
	}
};
window.customElements.define("variant-radios", VariantRadios);
//#endregion
